import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { api, AssetLocation, AssetType, IVehicleManagerAuditsAtLocation } from "../../../logic/api";
import styles from "../styles";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import VehicleAuditDueListItem from "../../../components/lists/listItems/VehicleAuditDue/VehicleAuditDueListItem";
import AuditsDueRow from "./condensedLayout/auditsDue/AuditsDueRow";
import HeaderRow from "./condensedLayout/HeaderRow";
import { useTranslation } from "react-i18next";

const VehicleAuditsDueAtLocation: React.FunctionComponent<{
    isCondensedView?: boolean;
    path: string;
    onSelected?: (locaiton: AssetLocation) => void;
}> = (props) => {
    const [params, setParams] = useState<IVehicleManagerAuditsAtLocation>({
        path: props.path
    });

    useEffect(() => {
        if (props.path != params.path) {
            setParams({
                ...params, path: props.path
            });
        }
    }, [props.path]);

    const { t } = useTranslation();

    return <div>
        {props.isCondensedView ? (<PagedDataView<IVehicleManagerAuditsAtLocation, AssetLocation>
            apiHook={api.hooks.vehicleManager.getAuditsDue}
            parameters={params}
            header={() => <HeaderRow columnHeaders={[t("booking.cards.status"), t("locations.dueDate"), t("locations.location")]} />}
            isTable
            animate={false}
            renderItem={(item, index) => {
                return <AuditsDueRow assetLocation={item} auditCategory={AssetType.vehicle} rowIndex={index} onClick={() => {
                    if (props.onSelected != null) {
                        props.onSelected(item);
                    }
                }} />
            }}>
            <div style={styles.noData}>
                {t("locations.noAuditsDue")}
            </div>
        </PagedDataView>)
            :
            (<PagedDataView<IVehicleManagerAuditsAtLocation, AssetLocation>
                apiHook={api.hooks.vehicleManager.getAuditsDue}
                parameters={params}
                renderItem={(item) => {
                    return <VehicleAuditDueListItem item={item} onClick={() => {
                        //history.push(paths.booking(item.id));
                        if (props.onSelected != null) {
                            props.onSelected(item);
                        }

                    }} />
                }}
            ><div style={styles.noData}>
                    {t("locations.noAuditsDue")}
                </div>
            </PagedDataView>)}
    </div>;
};

VehicleAuditsDueAtLocation.propTypes = {
    path: propTypes.string.isRequired,
    onSelected: propTypes.func
}

export default VehicleAuditsDueAtLocation;
